import React from 'react';
import ScheduleProviderCard from '@src/components/scheduling-provider-card/ScheduleProviderCard.jsx';
import ScheduleProviderCardUtils from '@src/js/provider-card-utils.js';
import { SessionStorageUtils } from '@js/utils/utils-imports.es6.js';

const DashboardCareTeamPage = props => {
  const onSchedulingClicked = event => {
    SessionStorageUtils.clearAppointmentSpecificSessionStorage();

    const currentTarget = event.currentTarget;
    const npi = JSON.parse(currentTarget.dataset.npi);
    window.location = `${props.onlineSchedulingLink}?npi=${npi}`;
  }

  const onSendAMessageClicked = () => {
    window.open(props.sendAMessageLink, '_blank').focus();
  }

  const getCallLink = event => {
    const location = JSON.parse(event.currentTarget.dataset.location);
    window.location = `${ScheduleProviderCardUtils.getLocationPhoneNumberLink(
      location.field_phone_1,
    )}`;
  }

  return (
    <>
      {props.careTeamProviders.length > 0 && (
        <>
          {props.careTeamProviders.map((provider, index) => {
            return <>
              {provider.npi === props.pcpNPI &&
                <div className="pcp-banner">
                  <div className="banner-text">
                    {props.pcpText}
                  </div>
                </div>
              }
              <div className="care-team-provider">
                <ScheduleProviderCard key={provider.npi + '-' + index} {...provider} />
                <div className="buttons-group">
                  {provider.hasOnlineScheduling &&
                    <button
                      className="base-button seafoam"
                      onClick={onSchedulingClicked}
                      data-npi={provider.npi}
                    >
                      {props.onlineSchedulingLabel}
                    </button>
                  }
                  {!provider.hasOnlineScheduling && provider.initialLocation && provider.initialLocation.field_phone_1 && !props.showSecondaryPhone &&
                    <button className="base-button seafoam" data-location={JSON.stringify(provider.initialLocation)} onClick={getCallLink}>{props.callToScheduleText}</button>
                  }
                  {provider.initialLocation && provider.initialLocation.field_phone_1 && props.showSecondaryPhone &&
                    <button className="base-button secondary outline" data-location={JSON.stringify(provider.initialLocation)} onClick={getCallLink}>{provider.callLabel}</button>
                  }
                  {props.sendAMessageLabel &&
                    <button className="base-button secondary outline" onClick={onSendAMessageClicked}>{props.sendAMessageLabel}
                      <svg className="external-link" xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 0 24 24" width="15px" fill="#248473"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1zM14 4c0 .55.45 1 1 1h2.59l-9.13 9.13c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L19 6.41V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1z"/></svg>
                    </button>
                  }
                </div>
              </div></>;
          })}
        </>
      )
      }
    </>
  );
};

export default DashboardCareTeamPage;
